if (!customElements.get('flip-card')) {
  customElements.define(
    'flip-card',
    class FlipCard extends HTMLElement {
      constructor() {
        super();

        this.cardWrapper = this.querySelector('.ingredient-card-wrapper');
        this.cardBackSide = this.querySelector('.card-back');
        this.readMoreBtn = this.querySelector('#read-more-btn');
      }

      connectedCallback() {
        this.readMoreBtn.addEventListener('click', this.handleBtnClick.bind(this));
        this.cardBackSide.addEventListener('click', this.handleBackSideClick.bind(this));
      }

      handleBtnClick(event) {
        event.stopPropagation();
        if (event.target) this.cardWrapper.classList.add('rotated');
      }

      handleBackSideClick(event) {
        event.stopPropagation();
        if (event.target) this.cardWrapper.classList.remove('rotated');
      }

      disconnectedCallback() {
        this.readMoreBtn.removeEventListener('click', this.handleBtnClick);
        this.cardBackSide.removeEventListener('click', this.handleBackSideClick);
      }
    }
  );
}
